import React from "react";
import { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Container, Navbar, Nav, NavDropdown} from "react-bootstrap";
import logo from "./imgs/YS-Logo-01.svg";
import account from "./imgs/account.png";
import adPoster from "./posters/learn more about advertising.pdf";
import { PATREON_URL } from "./constants/url.constants";
import Style from "./NavHeader.module.scss";
import Login from "./pages/AuthPage";
import AdFrame from "./pages/AdFrame";

function NavHeader({ show, setShow, admin, setAdmin, user, setUser}) {

  const [ad, setad] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  const handleAdvertise = () => {
    window.open(adPoster);
    if(user){ 
      setad(true);
     } else {
      setShow("flex");}
  }

  // Smart navigation function
  const handleSectionClick = (sectionId) => {
    if (location.pathname === '/') {
      // If we're on homepage, scroll to section
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    } else {
      // If we're on another page, navigate to homepage with hash
      navigate(`/#${sectionId}`);
    }
  };

  const handleLogoClick = (e) => {
    e.preventDefault();
    navigate('/');
  };

  // Handle hash navigation on page load/refresh
  useEffect(() => {
    if (location.hash && location.pathname === '/') {
      // Small delay to ensure page is loaded
      setTimeout(() => {
        const sectionId = location.hash.substring(1); // Remove # from hash
        const element = document.getElementById(sectionId);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);
    }
  }, [location]);

  return (
    <>
      <a href="/" onClick={handleLogoClick}><img src={logo} alt="Logo" className={Style.logo +" logo"} /></a>
      
      <Login setShow={setShow} show={show} admin={admin} setAdmin={setAdmin} user={user} setUser={setUser}/>
      {ad && <AdFrame setFrame={setad} />}
      <Navbar collapseOnSelect expand="lg" variant="light" sticky="top" >
        <div className={Style.navbar}>
        <Container className="navContainer">
          <Navbar.Toggle aria-controls="responsive-navbar-nav" style={{backgroundColor:"white"}}/>
          <Navbar.Collapse id="responsive-navbar-nav">
            <Nav className="ms-auto" style={{backgroundColor:"white", width: "min-content"}}>
              <Nav.Link 
                className="linkText" 
                onClick={(e) => {
                  e.preventDefault();
                  handleSectionClick('product');
                }}
                style={{cursor: 'pointer'}}
              >
                Product
              </Nav.Link>
              <Nav.Link 
                className="linkText" 
                onClick={(e) => {
                  e.preventDefault();
                  handleSectionClick('faq');
                }}
                style={{cursor: 'pointer'}}
              >
                FAQs
              </Nav.Link>
              <NavDropdown align="end" style={{width:"10%"}} className={Style.noCaret + " linkText"} title={<img src={account} className={Style.acc} alt=""/>} id="basic-nav-dropdown">

                <NavDropdown.Item className="linkText"onClick={()=>handleAdvertise()}>Advertise</NavDropdown.Item>
                {user? 
                  <>
                    <NavDropdown.Item className="linkText" rel="noopener noreferrer" target="_blank" onClick={()=>setAdmin(true)}>Upload Stories</NavDropdown.Item>
                    <NavDropdown.Item className="linkText" onClick={()=>setShow("flex")}>Sign Out</NavDropdown.Item>
                  </>
                  :
                  <>
                    <NavDropdown.Item className="linkText" onClick={()=>setShow("flex")}>Upload Stories</NavDropdown.Item>
                    <NavDropdown.Item className="linkText" onClick={()=>setShow("flex")}>Sign In/ Register</NavDropdown.Item>
                  </>
                }
                <NavDropdown.Item className="linkText" rel="noopener noreferrer" target="_blank" href={PATREON_URL}>Support us</NavDropdown.Item>
            </NavDropdown>
            </Nav>
          </Navbar.Collapse>
        </Container>
        </div>
      </Navbar>
    </>
  );
}

export default NavHeader;
